<template>
  <el-main class="container">
    <Nav>
      <div slot="left">
        <el-input placeholder="请输入房源名称进行搜索" v-model="inputVal" clearable></el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>

        <div class="industry-box">
          <span>项目筛选</span>
          <el-select v-model="selectProject" @change="handleProject" clearable class="select" placeholder="请选择项目">
            <el-option
              v-for="item in projectList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div slot="right">
        <el-button v-show="hasAuthority('addHouse')" type="primary" @click="handleAdd">新增房源</el-button>
      </div>
    </Nav>
    <div class="table-box">
      <Table
        border
        align="center"
        :column="tableInfo.column"
        :data="tableInfo.data"
        :header-row-style="{height: '100px'}"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        :row-style="{height: '100px'}"
        pagination
        background
        :paginationTop="'30px'"
        :paginationAlign="'center'"
        layout="prev, pager, next, sizes, jumper"
        :page-sizes="[5, 10, 20, 30]"
        :pager-count="5"
        :current-page.sync="body.pageIndex"
        :total="tableInfo.total"
        :page-size="body.pageSize"
        @size-change="handleSizeChange"
        @p-current-change="handleCurrentChange"
      ></Table>
    </div>
  </el-main>
</template>

<script>
import {
  getHouseList,
  getAllProject,
  setHouseTag,
  deleteHouse
} from '@/api/featured'
import env from '@/configs/env'
export default {
  data() {
    return {
      body: {
        pageSize: 10,
        pageIndex: 0,
        word: '',
        projectUuid: ''
      },
      tableInfo: {
        data: [],
        column: [
          {
            prop: 'indexNum',
            label: '排列序号'
          },
          {
            prop: 'name',
            label: '房源名称'
          },
          {
            prop: 'picture',
            label: '封面图',
            render: (h, scoped)=>{
              let url = `${env.qnImgDomain}${scoped.row.picture}`
              return(
                <div>
                  <img src={url} height={150}/>
                </div>
              )
            }
          },
          {
            prop: 'projectName',
            label: '所属精选项目'
          },
          {
            label: '操作',
            width: '300',
            render: (h, scoped) => {
              let text = ''
              scoped.row.status === 1 ? text = '显示' : text = '隐藏'
              return (
                <div>
                  <el-link v-show={this.hasAuthority('showHouse')} underline={false} type='primary' onClick={()=>{this.handleSetTag(scoped.row)}}>{text}</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('editHouse')} underline={false} type='primary' onClick={()=>{this.handleEdit(scoped.row)}}>编辑</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('deleteHouse')} underline={false} type='primary' onClick={()=>{this.handleDelete(scoped.row)}}>删除</el-link>
                </div>
              )
            }
          },
        ],
        total: 0,
      },
      selectProject: '',
      projectList: [],
      inputVal: '',
    }
  },
  async created() {
    await this.network().getAllProject()
    await this.network().getHouseList()
  },
  methods: {
    network() {
      return {
        getAllProject: async () =>{
          let { data } = await getAllProject()
          data.forEach(item => {
            this.projectList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        getHouseList: async ()=>{
          let { data } = await getHouseList(this.body)
          this.tableInfo.total = data.total
          this.tableInfo.data = data.list
        },
        setHouseTag: async(uuid) => {
          await setHouseTag(uuid)
          this.$message.success('更新成功')
          this.network().getHouseList()
        },
        deleteHouse: async (uuid) => {
          await deleteHouse(uuid)
          this.$message.success('删除成功')
          this.body.pageIndex = 1
          this.network().getHouseList()
        }
      }
    },
    handleSizeChange(size) {
      this.body.pageSize = size
      this.body.pageIndex = 1
      this.network().getHouseList()
    },
    handleCurrentChange(index) {
      this.body.pageIndex = index
      this.network().getHouseList()
    },
    handleAdd() {
      this.$router.push('/house-list/add')
    },
    handleProject(uuid){
      this.body.projectUuid = uuid
      this.body.pageIndex = 1
      this.network().getHouseList()
    },
    handleSearch(){
      this.body.word = this.inputVal
      this.body.pageIndex = 1
      this.network().getHouseList()
    },
    handleSetTag(row){
      this.network().setHouseTag(row.uuid)
    },
    handleDelete(row){
      this.$confirm('是否删除该房源？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteHouse(row.uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleEdit(row){
      this.$router.push(`/house-list/edit/${row.uuid}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.industry-box{
    margin-left: 60px;
    span{
      min-width: 80px;
    }
    .select{
      min-width: 150px;
    }
  }
</style>
